/* eslint-disable @angular-eslint/no-output-native */
import { Component, input, output } from '@angular/core';

import { PrivaButtonComponent } from '@priva/components/button';
import { PrivaGroupModule } from '@priva/components/group';
import { PrivaLocalizationModule } from '@priva/localization';

@Component({
    selector: 'app-manual-flow-footer',
    templateUrl: './manual-flow-footer.component.html',
    styleUrl: './manual-flow-footer.component.scss',
    imports: [PrivaButtonComponent, PrivaGroupModule, PrivaLocalizationModule],
})
export class ManualFlowFooterComponent {
    hasCancelBtn = input(true);
    cancelEnabled = input(true);
    info = input('');
    nextEnabled = input(true);

    cancel = output<void>();
    next = output<void>();
}
